<template>
  <div id="admin-setup">
    <!-- 收費項目設定 -->
    <div id="asetup" class="tab-pane fade show active" role="tabpanel" aria-labelledby="aps">
      <div class="col-12 table-style pt-2">
        <!-- 功能欄 -->
        <v-query-layout>
          <!-- 1 -->
          <v-label slot="ql1-text-1" LabText="篩選資料：" Labbold="true" />
          <input
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="filter"
          />
          <v-label
            v-if="Backend"
            slot="ql1-text-2"
            class="ml-2"
            LabText="查詢單位："
            Labbold="true"
          />
          <v-Dept
            v-if="Backend"
            slot="ql1-input-2"
            style="width: 290px;"
            :DeptData="NewDeptId"
            @SelectDept="SelectDept"
          />
          <!-- 2 -->
          <v-label slot="ql2-text-1" LabText="收費項目編號：" Labbold="true" />
          <input class="input-style" type="text" slot="ql2-input-1" v-model="FeeItemId" />
          <div slot="ql2-input-2">
            <v-button btn-text="查詢" btnOutline="primary" @click.native="InquireFeeitemQuery">
              <font-awesome-icon slot="icon" icon="search" />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="清除"
              btnOutline="secondary"
              @click.native="ClearCondition"
            >
              <font-awesome-icon slot="icon" icon="search-minus" />
            </v-button>
          </div>
          <!-- 3 -->
          <v-label slot="ql3-text-1" LabText="批次上傳：" Labbold="true" />
          <input
            id="XlsxData"
            class="input-style brr"
            type="file"
            ref="files"
            formenctype="multipart/form-data"
            style="line-height: 1.1; width: 230px;"
            slot="ql3-input-1"
            @change="onFileChanged"
          />
          <v-button
            class="mb-1 blr"
            btn-text="匯入"
            btnType="primary"
            slot="ql3-input-1"
            @click.native="PostOrderimport"
          />
          <v-label slot="ql3-text-2" class="ml-2" LabText="筆數：" Labbold="true" />
          <v-page slot="ql3-input-2" @RecPerPage="RecPerPage" />
          <button
            slot="exception"
            class="btn btn-link"
            style="text-decoration:underline;font-size: 0.8125rem;color: crimson;"
            @click="DownloadWithAxios"
          >
            *批次匯入範例檔案
          </button>
        </v-query-layout>
        <hr />
        <!-- 表格資料 -->
        <template>
          <b-table
            hover
            small
            bordered
            responsive
            show-empty
            empty-text="目前無資料"
            :items="items"
            :filter="filter"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            @filtered="onFiltered"
          >
            <!-- 單位 -->
            <template v-slot:cell(ApplyDeptId)="data">
              <div v-for="DeptIds in AllDeptData" :key="DeptIds.id" :value="DeptIds.DeptId">
                <div v-if="data.item.ApplyDeptId == DeptIds.DeptId">
                  {{ DeptIds.DeptName }}
                </div>
              </div>
            </template>
            <!-- 收費項目類型(判斷) -->
            <template v-slot:cell(FeeItemType)="data">
              <v-font v-if="data.item.FeeItemType === 1" fontText="公開項目" />
              <v-font v-else fontText="個人項目" />
            </template>
            <!-- 收費項目金額 -->
            <template v-slot:cell(FeeItemValue)="data">
              {{ data.item.FeeItemValue + ' 元' }}
            </template>
            <!-- 功能 -->
            <template v-slot:cell(Actions)="data">
              <v-button
                btn-text="新增單筆項目"
                title="單筆新增單據"
                btnSize="sm"
                btnType="primary"
                @click.native="AddSetupData(data.item)"
              />
            </template>
          </b-table>
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          />
        </template>
        <br />
      </div>
    </div>
    <!-- 新增單筆單據 modal -->
    <v-modal id="add_single">
      <div slot="header">
        新增繳款項目
      </div>
      <div slot="body">
        <div class="form-group">
          <v-label for="SFeeItemId" class="col-form-label" LabText="收費項目編號:" />
          <input
            id="FeeItemId"
            class="form-control"
            type="text"
            v-model="Orderadd.FeeItemId"
            disabled
          />
        </div>
        <div class="form-group">
          <v-label for="FeeItemId" class="col-form-label" LabText="收費項目名稱:" />
          <input
            id="FeeItemName"
            class="form-control"
            type="text"
            v-model="Orderadd.FeeItemName"
            disabled
          />
        </div>
        <div class="form-group">
          <v-font fontCss="small-color" fontText="*：必填項目" />
          <br />
          <label>
            <span class="small-color">*</span>
            繳款人是否為第一次註冊使用:
          </label>
          <div class="ml-4">
            <input
              id="FirstRegister1"
              class="form-check-input"
              type="radio"
              v-model="Orderadd.FirstRegister"
              value="true"
            />
            <v-label for="FirstRegister1" class="form-check-label" LabText="是" />
            <input
              id="FirstRegister2"
              class="form-check-input ml-2"
              type="radio"
              v-model="Orderadd.FirstRegister"
              value="false"
            />
            <v-label for="FirstRegister2" class="form-check-label ml-4" LabText="否" />
          </div>
        </div>
        <div class="form-group">
          <label for="OrderUserId" class="col-form-label">
            <span class="small-color">*</span>
            繳款項目所屬人員帳號:
          </label>
          <input id="OrderUserId" class="form-control" type="text" v-model="Orderadd.OrderUserId" />
        </div>
        <div class="form-group" v-if="Orderadd.FirstRegister === 'true'">
          <label for="OrderUserName" class="col-form-label">
            <span class="small-color">*</span>
            繳款項目所屬人員姓名:
          </label>
          <input
            id="OrderUserName"
            class="form-control nukWord"
            type="text"
            v-model="Orderadd.OrderUserName"
          />
        </div>
        <div class="form-group" v-if="Orderadd.FirstRegister === 'true'">
          <label for="OrderUserType" class="col-form-label">
            <span class="small-color">*</span>
            繳款項目所屬人員身分類別:
          </label>
          <select id="OrderUserType" class="form-control" v-model.number="Orderadd.OrderUserType">
            <option value="5">
              校外人士
            </option>
            <option value="6">
              廠商
            </option>
          </select>
        </div>
        <div class="form-group" v-if="Orderadd.FirstRegister === 'true'">
          <label for="OrderEmail" class="col-form-label">
            <span class="small-color">*</span>
            繳款項目所屬人員Email:
          </label>
          <input id="OrderEmail" class="form-control" type="email" v-model="Orderadd.OrderEmail" />
        </div>
        <div class="form-group" v-if="Orderadd.FirstRegister === 'true'">
          <label for="OrderTelephone" class="col-form-label">
            <span class="small-color">*</span>
            繳款項目所屬人員電話:
          </label>
          <input
            id="OrderTelephone"
            class="form-control"
            type="tel"
            v-model="Orderadd.OrderTelephone"
          />
        </div>
        <div class="form-group">
          <label for="OrderAddress" class="col-form-label">
            繳款項目所屬人員住址:
          </label>
          <input
            id="OrderAddress"
            class="form-control"
            type="text"
            v-model="Orderadd.OrderAddress"
          />
        </div>
        <div class="form-group">
          <label for="OrderUnino" class="col-form-label">
            <span class="small-color" v-if="Orderadd.OrderUserType === 6">
              *
            </span>
            繳款項目所屬人員統編:
          </label>
          <input id="OrderUnino" class="form-control" type="text" v-model="Orderadd.OrderUnino" />
        </div>
        <div class="form-group">
          <label for="FeeOrderDesc" class="col-form-label">
            繳款項目說明事由:
          </label>
          <textarea id="FeeOrderDesc" class="form-control" v-model="Orderadd.FeeOrderDesc" />
        </div>
        <div class="form-group">
          <label for="PayAmt" class="col-form-label">
            <span class="small-color">*</span>
            繳費金額:
          </label>
          <input id="PayAmt" class="form-control" type="text" v-model.number="Orderadd.PayAmt" />
        </div>
      </div>
      <div slot="footer">
        <v-button btn-text="新增" btnType="primary" @click.native="PostFeeitemOrderadd" />
        <v-button
          class="ml-1"
          btn-text="取消"
          btnType="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import axios from 'axios'
import vLabel from '@/components/Features/Label'
import vModal from '@/components/Features/ModalFloot'
import vQueryLayout from '@/components/Layout/QueryLayout'
import { apiFeeitemQuery, apiFeeitemOrderadd, apiFeeitemOrderimport } from '../../../Api/api'
export default {
  components: {
    'v-modal': vModal,
    'v-label': vLabel,
    'v-query-layout': vQueryLayout
  },
  name: 'setup_payment',
  data () {
    return {
      items: [],
      fields: [
        {
          key: 'SerialNo',
          label: '#',
          thClass: 'table-th',
          variant: 'info',
          sortable: true
        },
        {
          key: 'FeeItemId',
          label: '收費項目編號',
          thClass: 'table-th',
          sortable: true
        },
        { key: 'FeeItemName', label: '收費項目名稱', thClass: 'table-th' },
        {
          key: 'ApplyDeptId',
          label: '單位',
          thClass: 'table-th',
          sortable: true
        },
        {
          key: 'FeeItemType',
          label: '收費項目類型',
          thClass: 'table-th',
          sortable: true
        },
        {
          key: 'FeeItemValue',
          label: '收費項目金額',
          thClass: 'table-th',
          sortable: true,
          variant: 'warning'
        },
        { key: 'Actions', label: '功能', thClass: 'table-th' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: null,
      Orderadd: {
        FeeItemId: null,
        FirstRegister: false,
        OrderUserId: null,
        OrderUserName: null,
        OrderUserType: 0,
        OrderEmail: null,
        OrderTelephone: null,
        OrderAddress: null,
        OrderUnino: null,
        FeeOrderDesc: null,
        FeeItemName: null,
        PayAmt: 0
      },
      ApplyDeptId: '',
      AllDeptData: [],
      NewDeptId: sessionStorage.getItem('SetupDeptID')
        ? JSON.parse(sessionStorage.getItem('SetupDeptID'))
        : '',
      DeptId: [],
      CountData: [],
      FeeItemId: '',
      FileName: '',
      FileData: '',
      QueryData: {},
      Backend: false,
      selectedFile: '',
      errfunction: 0
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    this.PostFeeitemQuery()
    this.CheckQueryDept()
  },
  created () {
    // 從Dept組件接收部門資料
    this.$bus.$on('AllDept', data => {
      this.AllDepts(data)
    })
  },
  methods: {
    AllDepts (data) {
      // 從Dept組件取得部門資料
      if (this.errfunction === 0) {
        this.AllDeptData = data
        this.errfunction = 1
      }
    },
    SelectDept (vDeptId) {
      // 組件-部門
      this.NewDeptId = vDeptId
      sessionStorage.setItem('SetupDeptID', JSON.stringify(vDeptId))
    },
    RecPerPage (SublayerPage) {
      // 組件筆數
      this.perPage = SublayerPage
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    PostFeeitemQuery () {
      // 查詢 B_API 008
      var vm = this
      var NewData
      // API預設資料
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      // 查詢條件
      const SetupQuery = JSON.parse(sessionStorage.getItem('SetupQuery'))
      const Backend = md5('管理者')
      if (Backend === sessionStorage.getItem('Backend')) {
        // 管理者
        vm.Backend = true
        if (!SetupQuery) {
          // No QueryData
          vm.ApplyDeptId = ''
          vm.FeeItemId = ''
          UserData.ApplyDeptId = ''
          UserData.FeeItemId = ''
          NewData = Object.assign(IdentityData, UserData)
        } else {
          vm.ApplyDeptId = SetupQuery.ApplyDeptId
          vm.FeeItemId = SetupQuery.FeeItemId
          NewData = Object.assign(IdentityData, SetupQuery)
        }
      } else {
        // 業務
        if (!SetupQuery) {
          // No QueryData
          vm.ApplyDeptId = UserData.DeptId
          vm.QueryData = {}
          vm.QueryData.DeptId = UserData.DeptId
          vm.QueryData.ApplyDeptId = UserData.DeptId
          vm.QueryData.FeeItemId = vm.FeeItemId
          sessionStorage.setItem('SetupQuery', JSON.stringify(vm.QueryData))
          NewData = Object.assign(IdentityData, vm.QueryData)
        } else {
          vm.FeeItemId = SetupQuery.FeeItemId
          NewData = Object.assign(IdentityData, SetupQuery)
        }
      }
      // 呼叫API
      apiFeeitemQuery(NewData).then(res => {
        if (res !== undefined) {
          var num = 1
          var d = 0
          for (let i = 0; i < res.Data.length; i++) {
            const Data = res.Data
            if (Data[i].CurrentType === 1) {
              // 只撈已審核資料
              Data[i].SerialNo = num // 流水號
              vm.CountData[d] = Data[i]
              d++
              num++
            }
          }
          vm.items = vm.CountData
          vm.totalRows = vm.items.length
          vm.CountData = []
        } else {
          $('#CheckError').modal('show')
        }
      })
    },
    InquireFeeitemQuery () {
      // 查詢條件
      // 定義資料
      var vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      NewData.FeeItemId = vm.FeeItemId
      // 判斷身分，區分單位
      if (vm.Backend) {
        if (vm.NewDeptId) {
          vm.ApplyDeptId = vm.NewDeptId.DeptId
        }
        NewData.ApplyDeptId = vm.ApplyDeptId
      } else {
        vm.ApplyDeptId = UserData.DeptId
        NewData.ApplyDeptId = vm.ApplyDeptId
      }
      NewData.DeptId = UserData.DeptId
      // 紀錄查詢條件
      const QueryData = {}
      QueryData.DeptId = UserData.DeptId
      QueryData.ApplyDeptId = vm.ApplyDeptId
      QueryData.FeeItemId = vm.FeeItemId
      sessionStorage.setItem('SetupQuery', JSON.stringify(QueryData))
      // 呼叫API
      apiFeeitemQuery(NewData).then(res => {
        if (res !== undefined) {
          var f = 0
          var num = 1
          for (let i = 0; i < res.Data.length; i++) {
            const Data = res.Data
            if (Data[i].CurrentType === 1) {
              // 只撈已審核資料
              Data[i].SerialNo = num // 流水號
              vm.CountData[f] = Data[i]
              f++
              num++
            }
          }
          vm.items = vm.CountData
          vm.totalRows = vm.items.length
          vm.CountData = []
        } else {
          $('#CheckError').modal('show')
        }
      })
    },
    ClearCondition () {
      // 清除查詢條件
      const vm = this
      sessionStorage.removeItem('SetupQuery')
      sessionStorage.removeItem('SetupDeptID')
      vm.ApplyDeptId = ''
      vm.NewDeptId = ''
      vm.FeeItemId = ''
      vm.filter = ''
      vm.selectedFile = ''
      vm.PostFeeitemQuery()
    },
    AddSetupData (data) {
      // 新增單筆項目
      const vm = this
      $('#add_single').modal('show')
      vm.Orderadd.FeeItemId = data.FeeItemId
      vm.Orderadd.PayAmt = data.FeeItemValue
      vm.Orderadd.FeeItemName = data.FeeItemName
    },
    PostFeeitemOrderadd () {
      // 新增繳款項目 B_API 011
      // 定義資料
      var ErrorText = ''
      const vm = this
      $('#add_single').modal('hide')
      const Identity = JSON.parse(sessionStorage.getItem('Identity'))
      const NewData = Object.assign(Identity, vm.Orderadd)
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      NewData.DeptId = UserData.DeptId
      // 防呆
      if (NewData.OrderUserId === null) {
        ErrorText = '請輸入繳款人員帳號。'
      }
      if (NewData.PayAmt <= 0) {
        ErrorText = '繳費金額不得低於1。'
      }
      if (NewData.FirstRegister === 'true') {
        if (NewData.OrderUserName === null) {
          ErrorText = '請輸入繳款項目所屬人員姓名。'
        }
        if (NewData.OrderUserType === 0) {
          ErrorText = '請選擇繳款項目所屬人員身分類別。'
        } else if (NewData.OrderUserType === 6) {
          if (NewData.OrderUnino === null) {
            ErrorText = '請輸入統編。'
          }
        }
        if (NewData.OrderEmail === null) {
          ErrorText = '請輸入繳款項目所屬人員Email。'
        }
        if (NewData.OrderTelephone === null) {
          ErrorText = '請輸入繳款項目所屬人員電話。'
        }
      }
      if (ErrorText !== '') {
        vm.ErrorModal(ErrorText)
        return false
      }
      // 呼叫API
      apiFeeitemOrderadd(NewData).then(res => {
        if (res !== undefined) {
          vm.$bus.$emit('Modals', '項目新增成功。')
          $('#CheckOk').modal('show')
        } else {
          $('#CheckError').modal('show')
        }
      })
    },
    onFileChanged (e) {
      this.selectedFile = e.target.files[0]
    },
    PostOrderimport () {
      // 匯入批次檔案 B_API 023
      const vm = this
      if (vm.selectedFile === '') {
        vm.ErrorModal('請選擇檔案')
        return false
      } else {
        const Identity = JSON.parse(sessionStorage.getItem('Identity'))
        const UserData = JSON.parse(sessionStorage.getItem('UserData'))
        const json = new FormData()
        json.append('data', vm.selectedFile)
        json.append('_method', 'post')
        var NewData = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Token: Identity.Token,
            UserId: Identity.UserId,
            DeptId: UserData.DeptId
          }
        }
        apiFeeitemOrderimport(json, NewData).then(res => {
          if (res.status === 200) {
            if (res.data.AdminFeeItemOrderImportResult.ErrorCode === 0) {
              vm.$bus.$emit('Modals', '匯入成功')
              $('#CheckOk').modal('show')
            } else if (res.data.AdminFeeItemOrderImportResult.ErrorCode === 41471) {
              vm.ErrorModal('檔案已標示錯誤範圍，請下載內容錯誤檔案')
              const ErrUrl =
                res.data.AdminFeeItemOrderImportResult.FileDir +
                '/' +
                res.data.AdminFeeItemOrderImportResult.FileName
              const link = document.createElement('a')
              link.href = ErrUrl
              link.setAttribute('download', res.data.AdminFeeItemOrderImportResult.FileName)
              document.body.appendChild(link)
              link.click()
            } else {
              vm.ErrorModal(res.data.Msg)
            }
          } else {
            vm.ErrorModal('請求完成，回應超出200')
          }
        })
      }
    },
    DownloadWithAxios () {
      // 批次範例檔
      var Durl
      if (window.g.APIServeIP === 'http://10.201.86.159') {
        Durl = window.g.APIServeIP + ':' + window.g.Dport + '/Nuk_dists/template/NUK_OrderAdd.xlsx'
      } else if (window.g.Dport === '85') {
        Durl = window.g.APIServeIP + ':' + window.g.Dport + '/Nuk_dists/template/NUK_OrderAdd.xlsx'
      } else {
        Durl = window.g.APIServeIP + '/Nuk_dists/template/NUK_OrderAdd.xlsx'
      }
      axios({
        method: 'get',
        url: Durl,
        responseType: 'arraybuffer'
      }).then(response => {
        this.FileDownload(response)
      })
    },
    FileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'NUK_OrderAdd.xlsx')
      document.body.appendChild(link)
      link.click()
    },
    ErrorModal (data) {
      // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    },
    CheckQueryDept () {
      // 未查詢選擇部門時
      if (this.ApplyDeptId === '') {
        this.NewDeptId = ''
      }
    }
  }
}
</script>

<style lang="scss">
.brr {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.blr {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>
